module.exports = __webpack_public_path__ + "static/img/douyin.95a3685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mob/douyin.png
// module id = Cdls
// module chunks = 0